import React, {useState} from "react"
import {CurrencySymbol} from "../../common/constants";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Input from "@amzn/meridian/input";
import RadioButton from "@amzn/meridian/radio-button";
import SectionDetails from "./sectionDetails";
import {fetchCountryCode} from "../../handler/ParentDataHandler";

const VarianceSection = ({
                             isExactAmount, onActualCashSubmittedChange, onCoinsChange, onCoinCashTypeChange,
                             onSoiledNotesChange, onSoiledCashTypeChange, onOthersCashChange,
                             onOthersCashTypeChange, onSLPRecoveryChange, onSLPRecoveryTypeChange, onTtLinkChange, onSLPTTLinkChange, currencyUnit
                         }) => {
    if (isExactAmount === 'true') return null;
    const [actualCashSubmitted, setActualCashSubmitted] = useState(0);
    const [coins, setCoins] = useState(0);
    const [coinCashType, setCoinCashType] = useState("SHORT");
    const [soiledNotes, setSoiledNotes] = useState(0);
    const [soiledCashType, setSoiledCashType] = useState("SHORT");
    const [othersCash, setOthersCash] = useState(0);
    const [slpRecovery, setSLPRecovery] = useState(0);
    const [othersCashType, setOthersCashType] = useState("SHORT");
    const [slpRecoveryType, setSLPRecoveryType] = useState("EXCESS");
    const [ttLink, setTtLinkChange] = useState();
    const [slpTTLink, setSLPTTLinkChange] = useState();
    const currencySymbol = CurrencySymbol[currencyUnit];
    const [countryCode, setCountryCode] = useState();

    const handleActualCashSubmittedChangeWithoutTruncation = event => {
        console.log({event});
        setActualCashSubmitted(event);
        onActualCashSubmittedChange(event);
    };


    const handleActualCashSubmittedChange = event => {
        console.log({event});
        setActualCashSubmitted(Math.trunc(event));
        onActualCashSubmittedChange(event);
    };

    const handleCoinsChange = event => {
        setCoins(Math.trunc(event));
        onCoinsChange(event);
    }

    const handleCoinCashTypeChange = event => {
        setCoinCashType(event);
        onCoinCashTypeChange(event);
    }

    const handleSoiledNotesChange = event => {
        setSoiledNotes(Math.trunc(event));
        onSoiledNotesChange(event);
    }

    const handleSoiledCashTypeChange = event => {
        setSoiledCashType(event);
        onSoiledCashTypeChange(event);
    }

    const handleOthersCashChange = event => {
        setOthersCash(Math.trunc(event));
        onOthersCashChange(event);
    }
    const handleSLPRecoveryChange = event => {
        setSLPRecovery(Math.trunc(event));
        onSLPRecoveryChange(event);
    }

    const handleOthersCashTypeChange = event => {
        setOthersCashType(event);
        onOthersCashTypeChange(event);
    }

    const handleSLPRecoveryTypeChange = event => {
        setSLPRecoveryType(event);
        onSLPRecoveryTypeChange(event);
    }


    const handleTTLinkChange = event => {
        setTtLinkChange(event);
        onTtLinkChange(event);
    }

    const handleSLPTTLinkChange = event => {
        setSLPTTLinkChange(event);
        onSLPTTLinkChange(event);
    }

    fetchCountryCode().then((countryCode) => {
        console.log("fetched country code ->",countryCode)
        setCountryCode(countryCode)});

    return (
        <Box>
            <Row>
                <SectionDetails title="Variance Details" description="Enter the amount to be created for this deposit"/>
            </Row>
            {countryCode==="AE" || countryCode==="SA" ? <Column spacing="medium">
                <Row widths="grid-8">
                    <Input
                        label="Amount"
                        type="number"
                        prefix={currencySymbol}
                        onChange={handleActualCashSubmittedChangeWithoutTruncation}
                        value={actualCashSubmitted}
                    />
                </Row>
                <Row widths="grid-8">
                    <Input placeholder="Trouble Ticket Link for Other Issues" size="xlarge" width="xlarge" type="url"
                           value={ttLink} onChange={handleTTLinkChange}/>
                </Row>
                </Column>
                : countryCode===""
                    ? <Row spacingInset="medium" alignmentHorizontal="center" >
                        Fetching Country code timed out. Refresh and retry
                    </Row>
                :
                <Column spacing="medium">
                <Row widths="grid-5">
                    <Input
                        label="Actual Cash Submitted"
                        type="number"
                        prefix={currencySymbol}
                        onChange={handleActualCashSubmittedChange}
                        value={actualCashSubmitted}
                    />
                </Row>
                 <Row widths={["grid-5", "grid-2", "grid-2"]}>
                    <Input
                        label="Coins"
                        type="number"
                        prefix={currencySymbol}
                        value={coins}
                        onChange={handleCoinsChange}
                    />
                    <RadioButton
                        checked={coinCashType === "SHORT"}
                        onChange={handleCoinCashTypeChange}
                        name="coins_cash_type"
                        value="SHORT">
                        Short
                    </RadioButton>
                    <RadioButton
                        checked={coinCashType === "EXCESS"}
                        onChange={handleCoinCashTypeChange}
                        name="coins_cash_type"
                        value="EXCESS">
                        Excess
                    </RadioButton>
                </Row>
                <Row widths={["grid-5", "grid-2", "grid-2"]}>
                    <Input
                        label="Soiled Notes"
                        type="number"
                        prefix={currencySymbol}
                        value={soiledNotes}
                        onChange={handleSoiledNotesChange}
                    />
                    <RadioButton
                        checked={soiledCashType === "SHORT"}
                        onChange={handleSoiledCashTypeChange}
                        name="soiled_cash_type"
                        value="SHORT">
                        Short
                    </RadioButton>
                    <RadioButton
                        checked={soiledCashType === "EXCESS"}
                        onChange={handleSoiledCashTypeChange}
                        name="soiled_cash_type"
                        value="EXCESS">
                        Excess
                    </RadioButton>
                </Row>
                <Row widths={["grid-5", "grid-2", "grid-2"]}>
                    <Input
                        label="Others"
                        type="number"
                        prefix={currencySymbol}
                        value={othersCash}
                        onChange={handleOthersCashChange}
                    />
                    <RadioButton
                        checked={othersCashType === "SHORT"}
                        onChange={handleOthersCashTypeChange}
                        name="others_cash_type"
                        value="SHORT">
                        Short
                    </RadioButton>
                    <RadioButton
                        checked={othersCashType === "EXCESS"}
                        onChange={handleOthersCashTypeChange}
                        name="others_cash_type"
                        value="EXCESS">
                        Excess
                    </RadioButton>
                </Row>
                <Row widths="grid-8">
                    <Input placeholder="Trouble Ticket Link for Other Issues" size="xlarge" width="xlarge" type="url"
                           value={ttLink} onChange={handleTTLinkChange}/>
                </Row>
                <Row widths={["grid-5", "grid-2", "grid-2"]}>
                    <Input
                        label="SLP recovery"
                        type="number"
                        prefix={currencySymbol}
                        value={slpRecovery}
                        onChange={handleSLPRecoveryChange}
                    />
                    <RadioButton
                        disabled
                        checked={slpRecoveryType === "SHORT"}
                        onChange={handleSLPRecoveryTypeChange}
                        name="slp_recovery_type"
                        value="SHORT">
                        Short
                    </RadioButton>
                    <RadioButton
                        checked={slpRecoveryType === "EXCESS"}
                        onChange={handleSLPRecoveryTypeChange}
                        name="slp_recovery_type"
                        value="EXCESS">
                        Excess
                    </RadioButton>
                </Row>
                <Row widths="grid-8">
                    <Input placeholder="Trouble Ticket Link for SLP recovery" size="xlarge" width="xlarge" type="url"
                           value={slpTTLink} onChange={handleSLPTTLinkChange}/>
                </Row>
            </Column>}
        </Box>);
}

export default VarianceSection;



// WEBPACK FOOTER //
// ./src/component/modal/deposit/varianceSection.js